// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconPrivateDining = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 25 24', fill: 'none', ...props },
    <path
      d="M22.39 1.93c-.27-.66-.98-1.03-1.68-.9-.7.14-1.21.76-1.21 1.47v20.25c0 .41.34.75.75.75s.75-.34.75-.75V16h1.5c.82 0 1.5-.67 1.5-1.57.01-3.81.02-8.56-1.61-12.5zM21 14.5v-12c1.52 3.67 1.51 8.25 1.5 12H21zM4.5 1.75v6c0 .98-.63 1.8-1.5 2.11v12.89c0 .41-.34.75-.75.75s-.75-.34-.75-.75V9.86C.63 9.55 0 8.72 0 7.75v-6C0 1.34.34 1 .75 1s.75.34.75.75v6c0 .41.34.75.75.75S3 8.16 3 7.75v-6c0-.41.34-.75.75-.75s.75.34.75.75zm12.55 6.27c.28.3.27.78-.04 1.06a.751.751 0 01-1.06-.04c-2.28-2.45-6.12-2.73-8.73-.63a.746.746 0 11-.94-1.16c3.23-2.59 7.96-2.25 10.77.77zm-.04 10.4c.3.28.32.76.04 1.06a7.96 7.96 0 01-5.8 2.52c-2.19 0-4.3-.92-5.8-2.52-.28-.3-.27-.78.04-1.06.3-.28.78-.27 1.06.04a6.43 6.43 0 009.4 0c.29-.31.76-.32 1.06-.04z"
      fill="currentColor"
    />
  );
export default SvgIconPrivateDining;
